import {
  Text,
  HStack,
  Flex,
  Box,
  useColorModeValue,
} from '@chakra-ui/react';
import React from 'react';

import type { NavGroupItem } from 'types/client/navigation';

import { useI18n } from 'lib/i18n/context';
import IconSvg from 'ui/shared/IconSvg';

import NavLinkIcon from '../NavLinkIcon';

type Props = {
  item: NavGroupItem;
  onClick: () => void;
  isExpanded?: boolean;
  activeBg?: string;
};

const NavLinkGroup = ({ item, onClick, isExpanded, activeBg }: Props) => {
  const { t } = useI18n();
  const textColor = useColorModeValue('#2A2A2E', '#EFEFEF');
  const defaultActiveBg = useColorModeValue('#F5F5F5', '#222222');
  const tabBg = activeBg ?? defaultActiveBg;
  const iconColor = useColorModeValue('gray.500', '#EFEFEF');

  return (
    <Box
      as="li"
      listStyleType="none"
      w="100%"
      onClick={ onClick }
      cursor="pointer"
    >
      <Flex
        h="48px"
        px={ 4 }
        alignItems="center"
        justifyContent="space-between"
        w="100%"
        bg={ isExpanded ? tabBg : 'transparent' }
        _hover={{ bg: tabBg }}
        _active={{ bg: tabBg }}
        aria-label={ t('navigation.textLinkGroup', { text: item.text }) }
      >
        <HStack spacing="12px">
          <NavLinkIcon item={ item } size={ 16 }/>
          <Text
            fontSize="14px"
            fontWeight={ 500 }
            lineHeight="16px"
            color={ textColor }
          >
            { item.text }
          </Text>
        </HStack>
        <IconSvg
          name="arrows/east-mini"
          boxSize={ 6 }
          color={ iconColor }
          transform={ isExpanded ? 'rotate(-90deg)' : 'rotate(90deg)' }
          transition="transform 0.2s ease"
        />
      </Flex>
    </Box>
  );
};

export default NavLinkGroup;
